import React from 'react';
import { TipsMapFunType, TipsMapType } from '../index';

export const aiTaskDownloadDisabledTips: TipsMapType = {
  en: (
    <>
      The report is being prepared and will be available for download when
      completed
    </>
  ),
  zh: <>报告尚未完成，完成后可下载报告</>,
};

export const aiTaskGameIconTips: TipsMapFunType = (name: string) => {
  return {
    en: (
      <>
        {name} <br /> Click to visit this game
      </>
    ),
    zh: (
      <>
        {name} <br /> 点击前往该游戏
      </>
    ),
  };
};
